import { ProcessDetailsForInstancePage } from "processInstanceList/components/ProcessInstanceListPage";
import * as AppPath from "./AppPath";
import { getAgentGroup, State } from "./State";

export const setInstanceListTitle = (title: string) => {
    document.title = title;
};

export const setProcessListTitle = (isSubprocessList: boolean, agentGroupDisplayName: string) => {
    document.title = `${isSubprocessList ? FRENDS.Localizations.Subprocesses : FRENDS.Localizations.Processes} ${agentGroupDisplayName}`;
};

export const setProcessListTitleFromState = (state: State) => {
    const selectedAgentGroup = getAgentGroup(state, state.currentAgentGroupName);
    const agentGroupDisplayName = selectedAgentGroup != null ? selectedAgentGroup.displayName : null;
    setProcessListTitle(AppPath.isSubprocessList(), agentGroupDisplayName || FRENDS.Localizations.Unknown);
}
export const setProcessInstanceListTitle = (processes: ProcessDetailsForInstancePage[]) => {
    // Take 3 first process names
    let processNames = processes && processes
        .slice(0, 3)
        .map((p) => p.name)
        .join(", ");

    if (processes.length > 3) {
        processNames = `${processNames} + ${processes.length - 3} ${FRENDS.Localizations.Processes.toLowerCase()}`;
    }
    const processNameTitle = " - " + processNames || FRENDS.Localizations.ProcessNotFound;
    const title = `${FRENDS.Localizations.ProcessInstances}${processNameTitle}`;
    setInstanceListTitle(title);
}